/* ============================================================
   ELKE PLASTIC — FILTER POPUP CLOSE HANDLER
   Closes open <details> filter popups on outside click + Escape.
   ============================================================ */
(function () {
  'use strict';

  var FILTER_SELECTORS = [
    '#main-collection-filters details[open]',
    'details.disclosure-has-popup[open]',
    'details.js-filter[open]',
    'details.facets__disclosure[open]'
  ];

  function getOpenFilterDetails() {
    var nodes = document.querySelectorAll(FILTER_SELECTORS.join(','));
    return Array.prototype.slice.call(nodes);
  }

  function closeOutside(event) {
    var openDetails = getOpenFilterDetails();
    if (!openDetails.length) return;
    openDetails.forEach(function (details) {
      if (!details.contains(event.target)) {
        details.removeAttribute('open');
      }
    });
  }

  function closeAllOnEscape(event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    var openDetails = getOpenFilterDetails();
    openDetails.forEach(function (details) {
      details.removeAttribute('open');
    });
  }

  function init() {
    document.addEventListener('click', closeOutside, true);
    document.addEventListener('keydown', closeAllOnEscape, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
